import { Controller } from "@hotwired/stimulus"

// Top-level section switcher for the newsletter content-scheduling screen.
// On large screens both sections (Scheduled + Add Content) are shown
// side-by-side via Tailwind `lg:block`; on small screens only one is visible
// at a time so the user isn't forced to scroll the whole world. Toggling
// `hidden` is a no-op on desktop because `lg:block` overrides it.
export default class extends Controller {
  static targets = ["section", "tab"]

  connect() {
    this.activate(this.defaultSection)
  }

  show(event) {
    this.activate(event.currentTarget.dataset.section)
  }

  activate(section) {
    this.sectionTargets.forEach((el) => {
      el.classList.toggle("hidden", el.dataset.section !== section)
    })

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.section === section
      tab.classList.toggle("bg-surface", active)
      tab.classList.toggle("text-ink", active)
      tab.classList.toggle("shadow-sm", active)
      tab.classList.toggle("text-ink-soft", !active)
      tab.setAttribute("aria-selected", active ? "true" : "false")
    })
  }

  get defaultSection() {
    return this.element.dataset.contentTabsDefault || "library"
  }
}
